
import { getRscObject } from "helpers/rsc"
import { ResultRank } from "components/presentation/ResultRank"
import Label from "components/general/Label"
import SportCode from 'components/common/SportCode'
import { findArray, RscFromStore } from 'helpers/utils'
import { useEventUnit } from "components/common/EventUnit"



export const CATEGORY = {
    "RACE": "A",
    "THROWS": "B",
    "HJUMPS": "C",
    "VJUMPS": "D",
};


/**
 * Return String RSC Event composed DISCIPLINE+SEX+EVENT
 * 
 * Example: ATHM200M--------------
 *
 * @_rsc : RSC Code  to extract long Event 
 */

export function getIsEvent800m(rsc) {
    return (rsc.match("ATH[MW]800M.+") || rsc.match("ATH[MW]HEPTATH-----------800.+"));
}

export function getIsEvent1500m(rsc) {
    return (rsc.match("ATH[MW]1500M.+") || rsc.match("ATH[MW]DECATH------------1500.+"));
}

export function getIsEvent5000m(rsc) {
    return (rsc.match("ATH[MW]5000M.+"));
}

export function getIsEventRoad(rsc) {
    return (rsc.match("ATH[MW]((.*?)WALK.+|MARATHON).+"));
}

export function getIsEventRelay(rsc) {
    return (rsc.match("ATH[MWX]4X.+"));
}

export function getIsEventCombined(rsc) {
    return (rsc.match("ATH[MW]DECATH.+") || rsc.match("ATH[MW]HEPTATH.+"));

}

export function getIsEventDecathlon(rsc) {
    return (rsc?.match("ATH[MW]DECATH.+"));

}

export const COMBINED = {
    "DECATHLON": ["ATHMDECATH------------100---------", "ATHMDECATH------------LJ----------", "ATHMDECATH------------SP----------", "ATHMDECATH------------HJ----------", "ATHMDECATH------------400---------", "ATHMDECATH------------110H--------", "ATHMDECATH------------DT----------", "ATHMDECATH------------PV----------", "ATHMDECATH------------JT----------", "ATHMDECATH------------1500--------"],
    "HEPTATHLON": ["ATHWHEPTATH-----------100H--------", "ATHWHEPTATH-----------HJ----------", "ATHWHEPTATH-----------SP----------", "ATHWHEPTATH-----------200---------", "ATHWHEPTATH-----------LJ----------", "ATHWHEPTATH-----------JT----------", "ATHWHEPTATH-----------800---------"]
};

export function getIsCombiExceptions(rsc) {
    return (rsc.match("ATH[MW]DECATH------------DT.+") || rsc.match("ATH[MW]DECATH------------JT.+") || rsc.match("ATH[MW]HEPTATH-----------JT.+"));

}

export const isPhaseFinal = (rsc) => {
    const { event, phase } = getRscObject(rsc);
    return phase.includes("FNL-");
}

export const isPhaseQual = (rsc) => {
    const { event, phase } = getRscObject(rsc);
    return phase.includes("QUAL");
}

export function getIsTracks(rsc, config) {
    const isStartingLine = findArray(config?.extendedConfig, { code: ['START_IN_LANES'] }).value === 'Y' ? true : false
    const isEvent800 = getIsEvent800m(rsc);
    const isEvent1500m = getIsEvent1500m(rsc);
    const isEvent5000m = getIsEvent5000m(rsc);
    const isEventRelay = getIsEventRelay(rsc);

    let resp = false;
    if (isStartingLine || isEvent800 || isEvent1500m || isEvent5000m || isEventRelay) {
        resp = true;
    }
    return resp
}

export function hasSummary(rsc, config, type) {
    const isUnitPhase = findArray(config?.extendedConfig, { code: ['UNITS_PHASE'] })
    let resp = false;

    // if (isUnitPhase || type == 'B' || type == 'C' || type == 'D') 
    if (isUnitPhase) {
        resp = true;
    }

    return resp
}

function columnTitles() {
    return (

        {
            Header: '',
            accessor: 'sortOrder',
            id: 'FixedTitles',
            Cell: (props) => {
                return (
                    <div>
                        <div className="d-flex"><Label data='HeaderResult' /></div>
                        <div className="d-flex">&nbsp;</div>
                        <div className="d-flex"><Label data='HeaderPoints' /></div>
                        <div className="d-flex"><Label data='HeaderTotal' /></div>
                    </div>
                )
            }
        }
    )
}
export function CreateColumnsCombined(events, rsc, eu) {

    let columnsExt = []


    events.map((event, index) => {
        if (index === 0) {
            columnsExt.push(columnTitles());
        }
        let unitDesc = eu(event, true)
        columnsExt.push(
            {
                Header: unitDesc,
                accessor: (row) => {
                    let ev = row?.items?.find(item => item?.eventUnit?.code === event)
                    return (ev?.sortOrder)
                },
                isVisible: false,
                disableSortBy: false,
                disableSort: true,
                columnIndex: index + 1,
                id: 'Event-' + index,
                headerClassName: 'text-center w-10',
                sortType: "absoluteOrderNumber",
                Cell: (props) => {
                    let row = props.cell.row.original
                    let ev = row?.items?.find(item => item?.eventUnit?.code === event)
                    let wind = ev?.extendedResults?.find(item => item.er_code === 'WIND_SPEED')?.er_value
                    let pts = ev?.extendedResults?.find(item => item.er_code === 'TOTAL_PTS')?.er_value
                    let rk = ev?.extendedResults?.find(item => item.er_code === 'TOTAL_PTS')?.er_rank
                    //let rsc = rsc  //RscFromStore()
                    let discipline = getRscObject(rsc).discipline
                    let resultIrm = ev?.irm
                    let resultType = ev?.resType
                    return (
                        <div>
                            {resultType !== 'IRM'
                                ? <ResultRank result={ev?.resValue} rank={ev?.rank} />
                                : <div className="d-flex justify-content-end"><SportCode discipline={discipline} entity='@IRM' code={resultIrm} abbr={true} /></div>
                            }
                            <div className="d-flex justify-content-end">&nbsp;{wind !== undefined ? `(${wind})` : ''}</div>
                            <div className="d-flex justify-content-end">{ev?.resPoints}</div>
                            <ResultRank result={pts} rank={rk} />
                        </div>
                    )
                }
            },

        )
    })

    return columnsExt
}



